import './app/src/main.js';
import './wordpress/wp-content/themes/gmptwentynineteen/scripts/theme';
